__webpack_require__.p = "https://techminds.pstatic.net/pkgtour/statics/vertical-v2/455e06bf1bb7b0d7061827c418995bd56d57f392/_next/";